export function wrapHtmlSelection(
  value: string,
  start: number,
  end: number,
  open: string,
  close: string,
  emptySelectionFallback: string,
): { next: string; selStart: number; selEnd: number } {
  const sel = value.slice(start, end);
  const mid = sel.length > 0 ? sel : emptySelectionFallback;
  const inserted = open + mid + close;
  const next = value.slice(0, start) + inserted + value.slice(end);
  const selStart = start + open.length;
  const selEnd = selStart + mid.length;

  return { next, selStart, selEnd };
}
